module.exports = __webpack_public_path__ + "static/toggl-plan-7c09c825341c9d6f76f6755e71b468f2.mp4";